import { z } from 'zod'

const envSchema = z.object({
  VITE_ENV: z.enum(['DEV', 'TST', 'PRD']),
  VITE_BACKEND_URL: z.string(),
  VITE_BACKEND_TOKEN: z.string(),
})

const _env = envSchema.safeParse(import.meta.env)

if (!_env.success) throw new Error('Invalid environment variables')

export const env = _env.data
